import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { bulkSetUserInfo } from "reducer/user.slice";
import api from "services/api";
import Header from "./header";
import Main from "./main";

export default function Layout() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    let token = sessionStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.post("/dao/get-customer-info", {}).then(async (rs: any) => {
      console.log("layout get info")
      dispatch(bulkSetUserInfo(rs));
      api.getTokenBalance();
      setLoading(false);
    }).catch(err => {
      setLoading(false);
    });
  }, []);

  return (
    <div>
      {loading ? (
        <p></p>
      ) : (
        <>
          <Header />
          <div className="main-layout">
            <div className="main-container">
              <Main />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
